import React from "react";

import TravellerStepOne from "img/how-to-img/world-tour.png";
import TravellerStepTwo from "img/how-to-img/mailbox.png";
import TravellerStepThree from "img/how-to-img/bill-receipt.png";
import TravellerStepFour from "img/how-to-img/product-delivery-tracking.png";

export default function HowToTraveller() {
  return (
    <div className="step-list">
            <h1 className="small-heading">Steps to Track a Delivery</h1>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepOne}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 1: Open the Tripple Air App
          </h1>
          <p className="small-para">
            Launch the Tripple Air mobile app on your device and log in using
            your registered email and password. Make sure notifications are
            enabled for real-time updates.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepTwo}
            alt="Step Two"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 2: Tap on 'My Deliveries'
          </h1>
          <p className="small-para">
            From the app's home screen or bottom menu, tap "My Deliveries" to
            view all your ongoing and completed deliveries.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepThree}
            alt="Step Three"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 3: Select a Delivery to Track
          </h1>
          <p className="small-para">
            Choose the specific delivery you want to monitor. You'll be taken to
            a live tracking page showing current status, location updates, and
            estimated delivery time.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepFour}
            alt="Step Four"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 4: Monitor Real-Time Updates
          </h1>
          <p className="small-para">
            Follow the delivery's journey in real time — from pickup to
            drop-off. You'll see key milestones like "Picked Up," "In Transit,"
            and "Delivered," along with QR scan confirmations at pickup and
            delivery.
          </p>
        </div>
      </div>
    </div>
  );
}
